import React from 'react'
import { CGE } from '../../../../common/components/CGE'
import { validateEmailFunc } from '../../../../common/utils/utilsFunc'
import DebtAndEndowmentContextProvider, { ACTIONS, DebtAndEndowmentContext } from '../../context/DebtAndEndowmentContextProvider';
import Loading from "../../../../common/components/Loading";
import AlertModal from '../../../../common/components/AlertModal';
import { useModal } from "@clayui/modal";
import { getPageLayoutType } from "../../../../common/utils/utilsFunc";


function DebtAndEndowmentPriv({ props, textNoId, textErrorFetch, title, description, typeCertificate, canal }) {
  const [loading, setLoading] = React.useState(false);
  const [state, dispatch] = React.useContext(DebtAndEndowmentContext);
  const [emptyError, setEmptyError] = React.useState(false);
  const [emptyClientError, setEmptyClientError] = React.useState(false);
  const [validateEmail, setValidateEmail] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [valueCheckBox, setValueCheckBox] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const [handleButton, setHandleButton] = React.useState(false);
  const [visibleModal, setVisibleModal] = React.useState(false);
  const [visibleModal2, setVisibleModal2] = React.useState(false);
  const [confirm, setConfirm] = React.useState(false);
  const [idClient, setIdClient] = React.useState(false);
  const [detailClientJson, setDetailClientJson] = React.useState([]);
  const [data, setData] = React.useState([]);
  const { observer, onClose } = useModal({
    onClose: () => {
      setVisibleModal(false);
      setVisibleModal2(false);
    }
  });
  let optionsIdsSelect = [];

  function handleClickButton() {

    if (validateEmail && !valueCheckBox) {
      setValidateEmail(false)
    }
    
    if(!idClient) {
      setEmptyError(true);
      setEmptyClientError(true)
      props.setGlobalAlert("Complete todos los campos obligatorios.", "warning");

    }else if(!detailClientJson.CTA_CTO) {
      setEmptyError(true);
      props.setGlobalAlert("Debes presionar Buscar número de cliente", "warning");
      setEmptyClientError(false);

    }else if(detailClientJson?.CTA_CTO !== idClient) {
      setEmptyError(true);
      props.setGlobalAlert("Debes presionar Buscar número de cliente", "warning");
      setEmptyClientError(false);

    }else if (valueCheckBox && !email) {
      setEmptyError(true);
      props.setGlobalAlert("Complete todos los campos obligatorios.", "warning");

    } else if (email && !validateEmailFunc(email)) {
      setValidateEmail(true);
      props.setGlobalAlert("Complete todos los campos obligatorios.", "warning");

    } else {
      setEmptyError(false);
      setValidateEmail(false);
      setErrorMessage("")
      setHandleButton(true)
      setEmptyClientError(false);
    }
  }

  React.useEffect(() => {
    if (handleButton) {
      setLoading(true);
      dispatch({
        payload: { handleButton, email, typeCertificate, canal },
        type: ACTIONS.SET_JSON_BUTTON,
      });
    }
  }, [handleButton])

  React.useEffect(() => {
    if (state.pagoCertificateWebContent) {
      setLoading(false)
      setHandleButton(false)

      if (state.pagoCertificateWebContent?.hasPayment) {
        setVisibleModal(true)
      } else {
        setVisibleModal(false)
      }

      if (state.pagoCertificateWebContent?.status === 500 || state.pdfCertificate?.message) {
        setErrorMessage(state.pdfCertificate?.message ? state.pdfCertificate?.message : textErrorFetch)
        setLoading(false);
      } else {
        setErrorMessage("")
      }
    }
  }, [state.pagoCertificateWebContent])

  React.useEffect(() => {
    setLoading(true);
    dispatch({
      payload: true,
      type: ACTIONS.SET_LOAD_PAGE,
    });
  }, []);

  React.useEffect(() => {
    if (state.idList) {
      setData(state.idList)
      setTimeout(() => {
        setLoading(false);
      }, 400);
    }
  }, [state.idList]);

  React.useEffect(() => {
    if (confirm) {
      setLoading(true)
      dispatch({
        payload: confirm,
        type: ACTIONS.SET_CONFIRM
      })
      setConfirm(false)
    }
  }, [confirm])

  React.useEffect(() => {
    if (state.pdfCertificate) {
      setHandleButton(false)
      setLoading(false);
      dispatch({
        payload: null,
        type: ACTIONS.SET_PDF
      })
      if (state.pdfCertificate?.status === 500 || state.pdfCertificate?.message) {
        setErrorMessage(state.pdfCertificate?.message && state.pdfCertificate?.status !== 500 ? state.pdfCertificate?.message : textErrorFetch)
        setLoading(false);
      } else {
        setErrorMessage("")
      }
    }

  }, [state.pdfCertificate])

  React.useEffect(() => {
    if (state.errorCatch?.message) {
      setErrorMessage(textErrorFetch)
      setLoading(false);
    } else {
      setErrorMessage("");
    }
  }, [state.errorCatch])

  function handleEmail(e) {
    setEmail(e.target.value)
  }

  React.useEffect(() => {
    if (!valueCheckBox) {
      setEmail("")
    }
  }, [valueCheckBox])

  React.useEffect(() => {
    if (errorMessage) {
      props.setGlobalAlert(errorMessage, "warning", true, "Advertencia");
    }
  }, [errorMessage]);

  function handleClickSearch() {
    if(idClient) {
      setEmptyClientError(false);
      setLoading(true);
      dispatch({
        payload: idClient,
        type: ACTIONS.SET_IDCLIENT,
      });
    } else {
      setEmptyClientError(true);
    }
  }

  let propsLabelInfoContent = {
      "setVisibleModal": setVisibleModal2,
      "observer": observer,
      "onClose": onClose,
      "visibleModal": visibleModal2,
      "titleModal": "Información",
      "status": "info",
      "content": state?.webContentTextInfo
  }

  React.useEffect(() => {
    if(state.detailClient){
      setLoading(false);
      if(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN || state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0) {
        if(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0){
          setDetailClientJson(state.detailClient?.ConsultarDetalleCtaCtoResponse?.ITEM)
        } else {
            setDetailClientJson([]);
            props.setGlobalAlert(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO?.TEXTO_RETURN ? state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO?.TEXTO_RETURN : (props.text_fetch_error) ,"warning", true, "Advertencia");
        }
      } else {
        setDetailClientJson([]);
        props.setGlobalAlert((props.text_fetch_error),"warning", true, "Advertencia");
      }
    }
  }, [state.detailClient])

  if (getPageLayoutType()) {
    optionsIdsSelect = [
      {
        label: "[Seleccione una opción]",
        value: "",
      },
    ];
    state.idList.forEach((id) => {
      optionsIdsSelect.push({ label: id, value: id });
    });
  }
  
  return (
    <>
      <CGE.Panel
        title={title}
        description={description}
      >
        <CGE.PanelContainer
          alingItensCenter={true}
          size="lg"
        >
          <CGE.Spacing type="md" />
          <CGE.DetailClient
            props={{
              handleChangePriv: (event) => {
                setIdClient(event.target.value)
              },
              idClient: idClient,
              hasError: emptyClientError,
              msgError: 'Debes ingresar el Nro de Cliente',
              idFormElement: "CuentaContrato",
              labelName: "Número de Cliente:",
              typeElement: getPageLayoutType() ? "select" : "input-mask",
              typeFormElement: "text",
              mandatoryElement: true,
              valuePriv: idClient,
              valuePub: idClient,
              listOptions: optionsIdsSelect,
              labelButton: "Buscar",
              handleClick: handleClickSearch,
              propsLabelInfoContent: propsLabelInfoContent,
              sizeButton: "sm",
              typeButton: "primary",
              versionButton:"button",
              maxLength:"12",
              formatChars:{
                  9: "[0-9]"
              },
              mask:"999999999999",
            }}
            propsDetail={{
              fullNameClient: "",
              comunaClient: detailClientJson?.COMUNA ? detailClientJson?.COMUNA : "",
              calleClient: detailClientJson?.CALLE ? detailClientJson?.CALLE : "",
              nCalleClient: detailClientJson?.NUMERO_CASA ? detailClientJson?.NUMERO_CASA : "",
              dptoBlockClient: (detailClientJson?.SUPLEMENTO || detailClientJson?.PISO) ? `${detailClientJson?.SUPLEMENTO} 
          ${detailClientJson?.PISO}` : "",
              ctaCtoClient: detailClientJson?.CTA_CTO
          }}
          />
          <CGE.Spacing type="md" />
          <CGE.FormsField
            checked={valueCheckBox}
            horizontal={true}
            labelName="Enviar certificado por correo electrónico"
            handleChange={() => setValueCheckBox((val) => !val)}
            idFormElement="numberClientId"
            typeFormElement="checkbox"
            mandatoryElement={false}
            typeElement="input"
          />
          {valueCheckBox &&
            <CGE.FormsField
              horizontal={true}
              checked={valueCheckBox}
              handleChange={(e) => handleEmail(e)}
              idFormElement="numberClientId"
              mandatoryElement={valueCheckBox}
              typeElement="input"
              labelName="Correo Electrónico"
              placeholder="Ingresar el correo electrónico"
              hasError={(emptyError && !email && valueCheckBox) || (validateEmail && valueCheckBox) ? true : false}
              msgError={valueCheckBox && "Debes ingresar un Correo Electrónico válido para el Titular."}
            />
          }
          <CGE.Button
            className="mx-auto"
            label="Ver Certificado"
            onClick={() => handleClickButton()}
            type="primary"
          />
        </CGE.PanelContainer>
        {loading && <Loading />}
        {visibleModal && (
          <AlertModal
            titleModal="Información"
            observer={observer}
            onClose={() => {
              onClose()
              dispatch({
                payload: null,
                type: ACTIONS.SET_JSON_BUTTON,
              })
            }}
            status="info"
            confirm="true"
            funcClick={() => {
              setConfirm(true);
              onClose();
            }}
          >
            <CGE.RenderContent textContent={state.pagoCertificateWebContent?.htmlContent} />
          </AlertModal>
        )}
      </CGE.Panel>
    </>
  )
}

const DebtAndEndowmentPrivWithProvider = ({
  props,
  textErrorFetch,
  title,
  description,
  typeCertificate,
  canal,
  textNoId

}) => (
  <DebtAndEndowmentContextProvider>
    <DebtAndEndowmentPriv
      props={props}
      title={title}
      description={description}
      typeCertificate={typeCertificate}
      canal={canal}
      textNoId={textNoId}
      textErrorFetch={textErrorFetch}
    />
  </DebtAndEndowmentContextProvider>
);

export default DebtAndEndowmentPrivWithProvider;